module.exports = __webpack_public_path__ + "img/chevron-down4.3c63eb7e.svg";